import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useUsersContext } from '../../../contexts/users.tsx';
import ProfileBody from './body.tsx';
import ProfileHeader from './header.tsx';

const Profile = () => {
    const { isLoggedIn } = useUsersContext();
    const navigate = useNavigate();

    React.useEffect(() => {
        if (!isLoggedIn)
            navigate("/login");
    }, [isLoggedIn, navigate]);

    if (!isLoggedIn)
        return null;

    return (
        <>
            <ProfileHeader />
            <ProfileBody />
        </>
    );
};

export default Profile;
